import { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { connect } from 'react-redux';
import PricingPlansPrice from '../PricingPlansPrice';
import withComponentName from '../../../../../../../decorators/withComponentName';

import Styles from './style.module.scss';

const cx = classNames.bind(Styles);

export class PricingPlansCardHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      logo,
      title,
      priceMonthly,
      priceAnnually,
      free,
      comingSoon,
      fromOverlay,
      contactUs,
      contactUsForPrice,
      onShowOverlay,
      onScrollToForm,
      isQuarterly,
      className: activePlanClassname,
      index,
      width,
    } = this.props;

    return (
      <div
        className={cx('PricingPlansCard__head',
          { '--padding': title === 'PERSONAL / DEVELOPER' },
          activePlanClassname,
          { 'from-overlay': fromOverlay })}
        onClick={onShowOverlay}
      >
        <div className={cx('PricingPlansCard__head--info')}>
          <div className={cx('logo', activePlanClassname, { [`logo--${index}`]: true })}>
            <img src={logo} alt={title} />
          </div>
          <div className={cx('info')}>
            {comingSoon && <span className={cx('coming-soon')}>COMING SOON</span>}
            <div className={cx('title')}>
              {title}
            </div>
            <div className={cx('price', { 'from-overlay': fromOverlay })}>
              {free && <span className={cx('free')}>Free</span>}
              {contactUsForPrice && isMobile && <span className={cx('free')}>Custom</span>}
              {priceMonthly && (
                <PricingPlansPrice
                  priceMonthly={priceMonthly}
                  priceAnnually={priceAnnually}
                  isQuarterly={isQuarterly}
                />
              )}
              {comingSoon && <span className={cx('coming-soon')}>COMING SOON</span>}
            </div>
          </div>
        </div>

        <div className={cx('PricingPlansCard__head--action')}>
          {comingSoon && <span className={cx('coming-soon', { '--margin-right': title === 'PERSONAL / DEVELOPER' })}>COMING SOON</span>}
          {(contactUs || contactUsForPrice) && (
            <span
              className={cx('contact-us', {
                'for-pricing': contactUsForPrice,
              })}
              onClick={() => onScrollToForm(fromOverlay)}
            >
              {`${(!contactUsForPrice || isMobile) ? 'Contact Us' : 'Contact Us for Pricing'}`}
            </span>
          )}
        </div>
        {(!fromOverlay && width < 768) && (
          <FontAwesomeIcon icon={faChevronRight} />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ common }) => ({
  width: common.width,
});

PricingPlansCardHeader.defaultProps = {
  fromOverlay: false,
  isQuarterly: false,
  className: '',
  onShowOverlay: () => { },
  onScrollToForm: () => { },
};

PricingPlansCardHeader.propTypes = {
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  priceMonthly: PropTypes.string.isRequired,
  priceAnnually: PropTypes.string.isRequired,
  free: PropTypes.bool.isRequired,
  comingSoon: PropTypes.bool.isRequired,
  fromOverlay: PropTypes.bool,
  contactUs: PropTypes.bool.isRequired,
  contactUsForPrice: PropTypes.bool.isRequired,
  isQuarterly: PropTypes.bool,
  className: PropTypes.string,
  onShowOverlay: PropTypes.func,
  onScrollToForm: PropTypes.func,
};

export default connect(mapStateToProps, null)(withComponentName(PricingPlansCardHeader));
